import Vue from "vue";
import * as MUTATIONS from "../config/constants/mutation-types";

export default {
  /**
   * Mutation llamada por el router
   * Ponemos la ruta en el state
   * @param {Object} state
   * @param {Object} payload
   */
  [MUTATIONS.ON_ROUTE]: (state, payload) => {
    Vue.set(state, "route", payload);
  },
  /**
   * Mostrar u ocultar el loader
   * @param {Object} context
   * @param {Boolean} payload estado
   */
  [MUTATIONS.ON_IS_LOADING]: (state, payload) => {
    Vue.set(state, "isLoading", !!payload);
  },
  /**
   * Mutation disparadas por el
   * step navigator para avanzar pasos
   * Cada action guarda el paso
   * actual en el store
   * @param {Object} state
   */
  [MUTATIONS.ON_PASO_1]: (state, payload) => {
    Vue.set(state, "paso1", payload);
  },
  [MUTATIONS.ON_PASO_1_SUCCESS]: (state, payload) => {
    Vue.set(state, "responseConsulta", payload);
  },
  [MUTATIONS.ON_PASO_2]: (state, payload) => {
    Vue.set(state, "paso2", payload);
  },
  [MUTATIONS.ON_PASO_3]: (state, payload) => {
    Vue.set(state, "paso3", payload);
  },
  [MUTATIONS.ON_PASO_4]: (state, payload) => {
    Vue.set(state, "paso4", payload);
  },
  [MUTATIONS.ADOBE_APP_STARTED]: (state, payload) => {
    Vue.set(state, "trackClickElement", payload);
  },
  [MUTATIONS.ADOBE_APP_ON_CLICK_START]: (state, payload) => {
    Vue.set(state, "trackOnClickStart", payload);
  },
  [MUTATIONS.ON_IS_EXCEEDED]: (state, payload) => {
    Vue.set(state, "isExceeded", payload);
  },
  [MUTATIONS.ON_MOCK]: (state, payload) => {
    Vue.set(state, "mock", payload);
  },
  [MUTATIONS.ON_NOTIFICATION_TOAST]: (state, payload) => {
    Vue.set(state, "notificationToast", payload);
  }
};
